module.exports=function(scope){ return `<!-- enrollmentIdentifier missing in request -->
{
    "meta": {
        "ok": false,
        "code": 400,
        "message": "You must pass an enrollmentIdentifier parameter."
    }
}

<!-- FaceMap or image missing in request -->
{
    "meta": {
        "ok": false,
        "code": 400,
        "message": "You must pass a valid FaceMap or image parameter."
    }
}

<!-- empty enrollmentIdentifier -->
{
    "meta": {
        "ok": false,
        "code": 400,
        "message": "Empty string not valid for parameter enrollmentIdentifier."
    }
}

<!-- empty FaceMap -->
{
    "meta": {
        "ok": false,
        "code": 400,
        "message": "Empty string not valid for parameter FaceMap."
    }
}

<!-- empty image -->
{
    "meta": {
        "ok": false,
        "code": 400,
        "message": "Empty string not valid for parameter image."
    }
}


<!-- enrollmentIdentifier must be up to 63 characters-->
{
    "meta": {
        "ok": false,
        "code": 400,
        "message": "Please provide up to 63 characters for enrollmentIdentifier."
    }
}

<!-- enrollmentIdentifier exists in database -->
{
    "meta": {
        "ok": false,
        "code": 400,
        "message": "An enrollment already exists for this enrollmentIdentifier."
    }
}

<!-- FaceMap or image are less then 20 characters -->
{
    "meta": {
        "ok": false,
        "code": 400,
        "message": "Source data length is < 20."
    }
}
`};


// WEBPACK FOOTER //
// ./src/resources/code/standard-server/response/failure/enrollment-post.json.tpl